import {combineReducers, configureStore} from "@reduxjs/toolkit"
import {useDispatch as useStoreDispatch} from "react-redux"
import {branchesApi} from "./features/branches/branchesApi"
import {deviceApi} from "./features/devise/deviceApi"
import {playlistApi} from "./features/playlist/playlistApi"
import auth from "./features/auth/authSlice"
import deviceAdd from "./features/device-add-requests/deviceAddRequestSlice"
import app from "features/appSlice"

export const reducer = combineReducers({
  [branchesApi.reducerPath]: branchesApi.reducer,
  [deviceApi.reducerPath]: deviceApi.reducer,
  [playlistApi.reducerPath]: playlistApi.reducer,
  auth,
  deviceAdd,
  app
})

export type StoreState = ReturnType<typeof reducer>
export type AppStore = typeof store
export type AppDispatch = typeof store.dispatch

export interface AppThunkProps {
  dispatch: AppDispatch
  state: StoreState
  extra?: unknown
  rejectValue?: unknown
}

export const useDispatch = () => useStoreDispatch<AppDispatch>()
export const store = configureStore({
  reducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({immutableCheck: false})
      .concat(branchesApi.middleware)
      .concat(deviceApi.middleware)
      .concat(playlistApi.middleware)
})
